/* ============================================================
   Floral · welcome discount auto-apply (added 2026-09-05, Adam)
   When the Klaviyo popup "Floral - New Website Email Signups (2026)"
   (form T79WGg) is submitted, silently hit Shopify's /discount/ route so
   NEW15 is attached to this session and shows at checkout without
   the visitor typing it. Shopify enforces the rules (first order only,
   once per customer, not combinable with Bundle & Save).
   ============================================================ */
(function(){
  'use strict';
  var FORM_ID = 'T79WGg';
  var CODE    = 'NEW15';
  var KEY     = 'floral_welcome15_applied';
  function apply(){
    try { if (sessionStorage.getItem(KEY)) return; } catch(e){}
    fetch('/discount/' + CODE + '?redirect=/', { credentials: 'same-origin', redirect: 'follow' })
      .then(function(){ try { sessionStorage.setItem(KEY, '1'); } catch(e){} })
      .catch(function(){});
  }
  window.addEventListener('klaviyoForms', function(e){
    var d = e && e.detail;
    if (d && d.type === 'submit' && d.formId === FORM_ID) apply();
  });
})();
